import type { AgentKey } from '../../api/siftApiClient';

// The RDS keys keep their original names so existing users' threads survive the agent split.
export const storageKey = (base: string, agentKey: AgentKey) =>
  agentKey === 'rds' ? base : `${base}_${agentKey}`;

const CONV_KEY = 'sift_agent_conversation_id';

export const newConversationId = () =>
  (typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `c${Date.now()}_${Math.random().toString(36).slice(2)}`);

/** The agent's current thread id: the one the chat widget archives turns under. */
export function loadConversationId(agentKey: AgentKey): string {
  const key = storageKey(CONV_KEY, agentKey);
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
  } catch {
    /* ignore */
  }
  const id = newConversationId();
  saveConversationId(agentKey, id);
  return id;
}

export function saveConversationId(agentKey: AgentKey, id: string): void {
  try {
    localStorage.setItem(storageKey(CONV_KEY, agentKey), id);
  } catch {
    /* ignore */
  }
}
